import { useState } from 'preact/hooks';
import { pemEncode, toBase64 } from '../../core/bytes/encoding';
import { fmtBytes } from '../format';
import { HexView } from './HexView';
import { SubTabs } from './Tabs';
import { ExportMenu } from './Export';

export interface RawItem {
  label: string;
  data: Uint8Array;
  /** PEM label when the bytes are a PEM-able structure (e.g. CERTIFICATE) */
  pemLabel?: string;
  filename: string;
}

export function RawTabs({ items }: { items: RawItem[] }) {
  const [i, setI] = useState(0);
  const cur = items[Math.min(i, items.length - 1)];
  if (!cur) return null;
  return (
    <div>
      <SubTabs items={items.map((it, k) => ({ key: String(k), label: `${it.label} · ${fmtBytes(it.data.length)}` }))} value={String(i)} onChange={(k) => setI(Number(k))} />
      <div class="toolbar" style="margin-bottom:0.5rem">
        <ExportMenu
          label={cur.label}
          formats={[
            ...(cur.pemLabel ? [{ label: 'PEM', filename: `${cur.filename}.pem`, mime: 'application/x-pem-file', text: () => pemEncode(cur.data, cur.pemLabel) }] : []),
            { label: cur.pemLabel ? 'DER' : 'Raw bytes', filename: cur.pemLabel ? `${cur.filename}.der` : `${cur.filename}.bin`, mime: cur.pemLabel ? 'application/pkix-cert' : 'application/octet-stream', bytes: cur.data },
            { label: 'Base64', filename: `${cur.filename}.b64.txt`, text: () => toBase64(cur.data) },
            { label: 'Hex', filename: `${cur.filename}.hex.txt`, text: () => cur.data.toHex() },
          ]}
        />
      </div>
      <HexView data={cur.data} />
    </div>
  );
}
